// JS
import React, { useState } from 'react';
import { ppHeadingOverridesOpen } from '../shared/utils';

// COMPS
import ProductShippingReturnsPopup from '../ProductShippingReturnsPopup';

// COMP
const ProductShippingReturns = ({
  data,
  shippingInformation,
  returnsInformation,
  PSRButtonInfoSection = false
}) => {
  const [showHidePSR, setShowHidePSR] = useState(false);

  return (
    <>
      {showHidePSR && (
        <ProductShippingReturnsPopup
          data={data}
          shippingInformation={shippingInformation}
          returnsInformation={returnsInformation}
          showHidePSR={showHidePSR}
          setShowHidePSR={setShowHidePSR}
        />
      )}
      <div
        className={`product-shipping-returns ${
          PSRButtonInfoSection ? 'lg:my-0' : ''
        }`}
      >
        {data && (
          <>
            <div className="block">
              <div
                id="product-shipping-returns-button-icon-id"
                className={'items-start product-shipping-returns-button'}
              >
                <div
                  className="product-shipping-returns-button-icon"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowHidePSR(true);
                    window.scrollLock();
                    ppHeadingOverridesOpen();
                  }}
                >
                  Free shipping &amp; returns
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ProductShippingReturns;
